import {ArrowUpIcon} from '@primer/octicons-react'
import {useEffect, useRef, useState} from 'react'

import useIntersectionObserver from '../../../../lib/hooks/useIntersectionObserver'

export interface BackToTopProps {
  onClick: () => void
}

const COPY = {
  aria: 'Back to top',
}

const defaultProps: Partial<BackToTopProps> = {}

const BackToTop: React.FC<BackToTopProps> = props => {
  const initializedProps = {...defaultProps, ...props}
  const {onClick} = initializedProps

  const [isVisible, setIsVisible] = useState<boolean>(false)
  const heroRef = useRef<HTMLDivElement | null>(null)

  const {isIntersecting: isHeroActive} = useIntersectionObserver(heroRef, {threshold: 0.4})

  useEffect(() => {
    heroRef.current = document.querySelector('#hero')
  }, [])

  useEffect(() => {
    setIsVisible(!isHeroActive)
  }, [isHeroActive])

  return (
    <div className={`BackToTop ${isVisible ? 'BackToTop--visible' : ''} p-responsive`}>
      <button onClick={onClick} aria-label={COPY.aria}>
        <ArrowUpIcon />
      </button>
    </div>
  )
}

export default BackToTop
